import { Component, inject } from '@angular/core';
import { NavigationService } from '@ngx-seatback/utils';

@Component({
  selector: 'app-hellotest1',
  templateUrl: './routing-test.component.html',
  styleUrls: ['./routing-test.component.scss'],
  standalone: false,
})
export class RoutingTestComponent {
  protected readonly navService = inject(NavigationService);

  route: string = '';

  routeToPoint() {
    this.navService.navigateToPoint(this.route);
  }
}
